export default {
  "nearby": "Près de moi",
  "alerts": "Alertes",
  "explore": "Explorer",
  "cart": "Panier",
  "account": "Compte",
  "services": "Services",
  "foodQuestion": "Que souhaitez-vous commander ?",
  "foodSearch": "Rechercher commerces, plats et produits",
  "nearYou": "PRÈS DE VOUS",
  "chooseLocation": "Choisissez votre position",
  "chooseLocationHelp": "Nous en avons besoin pour afficher les commerces qui livrent dans votre zone.",
  "chooseAddress": "Choisir l’adresse",
  "changeZone": "Changer de zone",
  "searchingStores": "Recherche des commerces…",
  "storesAvailable": "commerces disponibles",
  "noStores": "Aucun restaurant disponible dans votre zone.",
  "newStores": "Nouveaux commerces",
  "justArrived": "NOUVEAUTÉS",
  "newLabel": "Nouveau",
  "recommendedLabel": "Recommandé",
  "popularLabel": "Populaire",
  "recommendedEyebrow": "LES FAVORIS DU COMMERCE",
  "recommendedProducts": "Recommandés",
  "addProduct": "Ajouter",
  "openNow": "Ouvert",
  "closedNow": "Fermé",
  "exploreTitle": "Recherchez ce que vous voulez",
  "exploreHelp": "Trouvez les commerces, plats et produits disponibles dans votre zone.",
  "searchThreeChars": "Saisissez au moins 3 lettres.",
  "searching": "Recherche…",
  "noSearchResults": "Aucun résultat.",
  "businesses": "Commerces",
  "viewMenu": "Voir le menu",
  "servicesTitle": "Services pour vous",
  "servicesHelp": "Choisissez un service sans quitter l’application.",
  "loadingServices": "Chargement des services…",
  "enterService": "Demander le service",
  "anotherAddress": "Essayez une autre adresse.",
  "loadingMenu": "Chargement du menu…",
  "backStores": "Retour aux commerces",
  "searchMenu": "Rechercher dans ce menu",
  "noProducts": "Aucun produit trouvé",
  "anotherWord": "Essayez une autre recherche.",
  "minimumOrder": "Commande min.",
  "products": "Produits",
  "viewCart": "Voir le panier",
  "yourOrder": "VOTRE COMMANDE",
  "emptyCart": "Votre panier est vide",
  "emptyCartHelp": "Ajoutez des produits pour commencer votre commande.",
  "browseStores": "Voir les commerces",
  "subtotal": "Sous-total",
  "deliveryCheckout": "La livraison sera calculée selon votre adresse.",
  "checkoutContinue": "Continuer",
  "confirmOrder": "Confirmer la commande",
  "backCart": "Retour au panier",
  "deliverAt": "LIVRER À",
  "change": "Modifier",
  "reference": "Numéro, étage ou référence",
  "orderNote": "Note pour le commerce",
  "payment": "Mode de paiement",
  "cash": "Espèces à la livraison",
  "selected": "Sélectionné",
  "estimatedDelivery": "Livraison estimée",
  "total": "Total",
  "loginFinish": "Connectez-vous pour terminer",
  "loginContinue": "Se connecter et continuer",
  "tracking": "SUIVI",
  "myOrders": "Mes commandes",
  "loginOrders": "Connectez-vous pour voir vos commandes",
  "noOrders": "Vous n’avez pas encore de commande",
  "profile": "PROFIL",
  "myAccount": "Mon compte",
  "login": "Se connecter",
  "register": "Créer un compte",
  "name": "Nom",
  "phone": "WhatsApp / téléphone",
  "email": "E-mail",
  "password": "Mot de passe",
  "enter": "Entrer",
  "registerMe": "M’inscrire",
  "language": "Langue",
  "languageHelp": "S’applique à toutes les nouvelles sections",
  "notifications": "Notifications",
  "notificationsHelp": "Commandes, promotions et nouveautés",
  "notificationsEnabled": "Activées sur cet appareil",
  "notificationsBlocked": "Bloquées dans le navigateur",
  "notificationsBlockedHelp": "L’autorisation est bloquée. Ouvrez le cadenas ou les paramètres du site et autorisez les notifications.",
  "notificationsUnsupported": "Ce navigateur ne prend pas en charge les notifications",
  "notificationsError": "Impossible de demander l’autorisation. Réessayez.",
  "activate": "Activer",
  "review": "Vérifier l’autorisation",
  "logout": "Déconnexion",
  "history": "Historique et suivi",
  "whereDeliver": "Où livrons-nous ?",
  "sharedAddress": "Cette adresse sera partagée avec les restaurants, livraisons et futurs services.",
  "currentLocation": "Utiliser ma position",
  "locating": "Recherche de votre position…",
  "popularPlaces": "LIEUX POPULAIRES",
  "selectAddress": "Choisissez votre adresse",
  "allInOne": "TOUT AU MÊME ENDROIT",
  "exploreHuaraz": "Explorez Huaraz",
  "portalSub": "Repas, livraisons et nouveaux services près de vous.",
  "restaurants": "Restaurants",
  "taxiLabel": "Taxi",
  "supermarket": "Supermarché",
  "orderFood": "Commander repas et produits",
  "soon": "Bientôt",
  "available": "Disponible",
  "navBusinesses": "Commerces",
  "navJoin": "Rejoignez-nous",
  "heroTitle": "Tout Huaraz, livré à votre porte",
  "heroDescription": "Découvrez les restaurants, vos envies et les commerces locaux. Commandez en quelques étapes et recevez où que vous soyez.",
  "choose": "Choisissez",
  "favoriteBusiness": "votre commerce préféré",
  "order": "Commandez",
  "easySecure": "facilement et en sécurité",
  "receive": "Recevez",
  "atYourLocation": "à votre adresse",
  "exploreFromPc": "Explorer depuis mon PC",
  "localBusinesses": "Commerces locaux",
  "deliveryInHuaraz": "Livraison à Huaraz",
  "orderTracking": "Suivi de commande",
  "liveApp": "Application en direct",
  "shopHere": "Commandez directement ici",
  "shipments": "Livraisons",
  "openApp": "Ouvrir l’application",
  "dailyServices": "Des services pour votre quotidien",
  "dailyServicesDescription": "Achetez, envoyez et découvrez les options locales sur une seule plateforme.",
  "restaurantServiceDescription": "Commandez auprès des meilleurs commerces locaux.",
  "exploreBusinesses": "Explorer les commerces",
  "pickupDelivery": "Collecte et livraison",
  "pickupDescription": "Nous transportons votre colis du point A au point B.",
  "requestDelivery": "Demander une livraison",
  "taxiDescription": "Demandez un trajet rapide et sûr.",
  "temporarilyUnavailable": "Temporairement indisponible",
  "requestTaxi": "Demander un taxi",
  "verySoon": "Très bientôt",
  "buyLocal": "ACHETEZ LOCAL",
  "meetBusinesses": "Découvrez nos commerces",
  "previousBusinesses": "Commerces précédents",
  "nextBusinesses": "Commerces suivants",
  "growTogether": "GRANDISSONS ENSEMBLE",
  "joinDelivery": "Rejoignez Delivery Huaraz",
  "joinDescription": "Des outils pour vendre, livrer et gérer votre activité sur une plateforme créée pour Huaraz.",
  "forBusinesses": "POUR LES COMMERCES",
  "growSales": "Développez vos ventes",
  "growSalesDescription": "Recevez des commandes, gérez votre carte et touchez plus de clients sans perdre le contrôle.",
  "registerBusiness": "Inscrire mon commerce",
  "forDrivers": "POUR LES LIVREURS",
  "earnDelivering": "Gagnez de l’argent en livrant",
  "driverDescription": "Recevez commandes, livraisons et alertes depuis un outil intégré conçu pour la mobilité.",
  "applyDriver": "Postuler comme livreur",
  "footerDescription": "Repas, livraisons et services locaux au même endroit.",
  "enterApp": "Ouvrir l’application",
  "closeApp": "Fermer l’application",
  "gpsPrompt": "Activer le GPS garantit une adresse précise et une livraison sans problème.",
  "shopping": "Courses",
  "events": "Événements",
  "mobileJoinDescription": "Les commerces et les livreurs disposent de leurs propres outils, alertes et espaces de travail.",
  "haveBusiness": "Vous avez un commerce ?",
  "mobileBusinessDescription": "Recevez des commandes, gérez votre carte et touchez plus de clients à Huaraz.",
  "haveMotorcycle": "Vous avez une moto ?",
  "mobileDriverDescription": "Gagnez de l’argent avec les commandes, livraisons et nouveaux services depuis le panneau intégré.",
  "myAddresses": "Mes adresses",
  "addressHelp": "Maison, travail, hôtel et plus",
  "walletCredits": "Portefeuille et crédits",
  "walletHelp": "Soldes, recharges et avantages",
  "myFavorites": "Mes favoris",
  "favoriteHelp": "Commerces enregistrés",
  "myCart": "Mon panier",
  "cartHelp": "Continuer mes achats",
  "helpInfo": "Aide et informations",
  "helpInfoDesc": "Questions, politiques et conditions",
  "forgotPassword": "J’ai oublié mon mot de passe",
  "favoriteTitle": "Commerces favoris",
  "favoriteLogin": "Connectez-vous pour enregistrer vos favoris",
  "noFavoritesZone": "Aucun commerce favori dans votre zone",
  "favoriteEmptyHelp": "Enregistrez vos commerces préférés depuis leur menu.",
  "reviews": "AVIS",
  "backMenu": "Retour au menu",
  "noReviews": "Aucun avis publié pour le moment.",
  "infoTitle": "Aide et informations",
  "recoverAccess": "RÉCUPÉRER L’ACCÈS",
  "newPassword": "Nouveau mot de passe",
  "recoverHelp": "Vous recevrez un code à l’adresse e-mail enregistrée.",
  "sendCode": "Envoyer le code",
  "verifyCode": "Vérifier le code",
  "savePassword": "Enregistrer",
  "cartProductsTitle": "Produits dans votre panier",
  "clearCart": "Vider",
  "decreaseQuantity": "Réduire la quantité ou supprimer le produit",
  "increaseQuantity": "Augmenter la quantité",
  "cartCommentPlaceholder": "Ajoutez un commentaire ou des instructions pour le commerce…",
  "coupon": "Coupon",
  "applyCoupon": "Appliquer",
  "couponInvalid": "Ce coupon n’est pas valide.",
  "discountApplied": "Réduction appliquée",
  "paymentDetails": "Détails du paiement",
  "deliveryFee": "Frais de livraison",
  "businessCharge": "Frais du commerce",
  "discount": "Réduction",
  "totalToPay": "Total à payer",
  "confirmDeliveryAddress": "CONFIRMEZ VOTRE ADRESSE DE LIVRAISON",
  "selectAnAddress": "Choisissez une adresse",
  "verifyCurrentAddress": "Vérifiez que la commande sera livrée à votre position actuelle.",
  "addressConfirmed": "Adresse confirmée",
  "correctAddress": "Oui, c’est la bonne adresse",
  "confirmAddressHelp": "Vous devez la confirmer avant de continuer vers le paiement",
  "continuePayment": "Continuer vers le paiement",
  "fulfillmentQuestion": "Comment souhaitez-vous recevoir votre commande ?",
  "deliveryOption": "Livraison",
  "deliveryOptionHelp": "Nous la livrons à votre adresse",
  "pickupOption": "Retrait en magasin",
  "pickupOptionHelp": "Retirez-la lorsqu’elle est prête",
  "pickupAtStore": "Retrait au commerce",
  "pickupAddressHelp": "Consultez l’adresse du commerce",
  "pickupReadyHelp": "Le commerce vous avertira lorsque la commande sera prête.",
  "noCost": "Sans frais",
  "noDeliveryFee": "Sans frais de livraison",
  "howPayPickup": "Comment paierez-vous lors du retrait ?",
  "howPayDelivery": "Comment paierez-vous à la réception ?",
  "paymentMethodForLocation": "Mode de paiement disponible pour votre emplacement",
  "payOnDeliveryLabel": "PAIEMENT À LA LIVRAISON",
  "payOnDeliveryTitle": "Espèces, Yape ou Plin",
  "payOnDeliveryHelp": "Choisissez comment payer à l’arrivée de votre commande.",
  "choosePayment": "Choisir",
  "choosePaymentOnDelivery": "Choisissez comment payer à la livraison",
  "confirmAddressTitle": "Confirmez votre adresse",
  "addressMapInstructions": "Utilisez le GPS, puis déplacez le repère exactement jusqu’à l’entrée de livraison.",
  "savedAddressesTitle": "MES ADRESSES ENREGISTRÉES",
  "genericAddress": "Adresse",
  "useGpsNow": "Utiliser mon GPS maintenant",
  "gpsUnsupported": "Cet appareil ne permet pas d’obtenir une position GPS.",
  "gpsPermissionRequired": "L’autorisation de localisation est nécessaire pour utiliser le GPS.",
  "gpsUnavailableHelp": "Nous n’avons pas obtenu de position précise. Recherchez votre rue ou déplacez le repère.",
  "gpsAccuracy": "Précision approximative",
  "gpsMoveMarker": "Déplacez le repère pour la corriger.",
  "gpsConfirmPoint": "Confirmez le point sur la carte.",
  "addressSearchPlaceholder": "Recherchez une rue, avenue, un hôtel ou un repère",
  "search": "Rechercher",
  "addressNotFoundHelp": "Adresse introuvable. Déplacez le repère jusqu’à votre entrée.",
  "mapNotConfigured": "La carte n’est pas encore configurée.",
  "mapLoadFailed": "Impossible de charger la carte.",
  "dragMarkerHelp": "Faites glisser le repère jusqu’à votre entrée",
  "addressHouseLabel": "Numéro, étage ou repère",
  "addressHousePlaceholder": "Ex. Maison bleue, porte 2",
  "saveAs": "Enregistrer comme",
  "homeTag": "Maison",
  "workTag": "Travail",
  "hotelTag": "Hôtel",
  "otherTag": "Autre",
  "saveInMyAddresses": "Enregistrer dans Mes adresses",
  "savingAddress": "Enregistrement…",
  "confirmThisAddress": "Confirmer cette adresse",
  "popularHuarazPlaces": "Lieux connus de Huaraz",
  "noStoresAtPoint": "Aucun commerce trouvé pour ce point.",
  "gpsOutsideCoverageHelp": "Le GPS vous a peut-être placé hors de la zone de service. Déplacez le repère jusqu’à votre entrée.",
  "correctMapLocation": "Corriger la position sur la carte",
  "checkingCurrentLocation": "Vérification de votre position actuelle…",
  "checkAddressWithGps": "Vérifier cette adresse avec mon GPS",
  "locationVerifiedForOrder": "Position vérifiée pour cette commande.",
  "gpsMatchesDeliveryAddress": "Votre position actuelle correspond à l’adresse de livraison.",
  "youMayHaveMoved": "Il semble que vous soyez ailleurs",
  "currentLocationDistance": "Votre position GPS actuelle se trouve à environ {distance} km de l’adresse sélectionnée.",
  "useCurrentGpsAndAdjust": "Utiliser mon GPS et ajuster",
  "deliverToSelectedAddress": "Livrer à l’adresse sélectionnée",
  "gpsNeedsConfirmation": "Le GPS nécessite votre confirmation",
  "gpsAccuracyTooLow": "La précision actuelle est d’environ {accuracy} m. Vérifiez le point avant de commander.",
  "reviewLocationOnMap": "Vérifier la position sur la carte",
  "gpsCouldNotVerify": "Nous n’avons pas pu vérifier votre position",
  "addressVerificationExpired": "Nous devons vérifier à nouveau l’adresse de livraison. Vous allez revenir au panier.",
  "back": "Retour", "close": "Fermer", "home": "Accueil", "offers": "Offres",
  "loadingNavigation": "Chargement de la navigation", "mainNavigation": "Navigation principale",
  "customizeOrder": "Personnalisez votre commande", "loadingProduct": "Chargement du produit…",
  "chooseOptions": "Choisissez vos options", "chooseOneOption": "Choisissez une option", "chooseUpTo": "Choisissez jusqu’à {count}",
  "optional": "Facultatif", "additional": "Supplément", "additionals": "Suppléments",
  "continue": "Continuer", "continueAndAdd": "Continuer et ajouter pour",
  "exclusiveOffers": "OFFRES EXCLUSIVES", "yapePromos": "Promos Yape",
  "yapeSpecialPrices": "Prix spéciaux en payant avec Yape.", "yapeLocationHelp": "Pour confirmer quels commerces livrent chez vous.",
  "searchPromoOrBusiness": "Rechercher une promo ou un commerce", "loadingPromotions": "Chargement des promotions…",
  "promotionsLoadError": "Impossible de charger les promotions.", "noYapePromos": "Il n’y a pas encore de Promos Yape actives.",
  "comeBackForOffers": "Revenez bientôt pour découvrir de nouvelles offres.", "availablePromotions": "Promotions disponibles",
  "yapeOnly": "Yape uniquement", "viewMyOrder": "Voir ma commande", "benefitsForYou": "Vos avantages", "seeAll": "Voir tout",
  "exclusiveDiscounts": "Réductions exclusives", "accordingToPromotions": "Selon les promotions",
  "deliveriesAndPickups": "Livraisons et retraits", "accordingToCoverage": "Selon la zone couverte",
  "shoppingBenefits": "Avantages sur vos achats", "moreNewsSoon": "Bientôt plus de nouveautés",
  "category": "Catégorie", "backToCategories": "Retour aux catégories",
  "storesNearLocation": "Commerces disponibles près de votre position.", "searchIn": "Rechercher dans",
  "categoryAddressHelp": "Nous avons besoin de votre adresse pour afficher les commerces de cette catégorie.", "inYourZone": "DANS VOTRE ZONE",
  "loadingBusinesses": "Chargement des commerces", "businessesLoadError": "Impossible de charger les commerces.",
  "noCategoryBusinesses": "Aucun commerce {category} n’est disponible dans votre zone.",
  "discoverMenuPromotions": "Découvrez leur carte et leurs promotions.",
  "yapeExclusivePayment": "Promotion exclusive avec paiement Yape", "yapePromoOrderNotice": "Cette commande contient une Promo Yape.",
  "exclusivePaymentMethod": "MODE DE PAIEMENT EXCLUSIF", "payWithYape": "Payer avec Yape", "keepPromotionalPrice": "Nécessaire pour conserver le prix promotionnel",
  "integrationPending": "Intégration en attente", "storeClosed": "Le commerce est fermé", "checkoutStoreClosedHelp": "Vous ne pourrez pas confirmer cette commande avant la réouverture du commerce.",
  "selectOptionToContinue": "Sélectionnez une option pour continuer.", "cash": "Espèces", "cashChangeHelp": "Indiquez si vous avez besoin de monnaie", "coordinatedTransfer": "Virement coordonné",
  "cashAmountPlaceholder": "Avec combien paierez-vous ? Exemple : 50", "processing": "Traitement…", "confirmCashOrder": "Confirmer la commande en espèces",
  "confirmOrderWith": "Confirmer la commande avec {method}", "cashChangeInstructions": "Si vous avez besoin de monnaie, saisissez la valeur du billet. Sinon, laissez ce champ vide.",
  "transferPickupInstructions": "Aucun débit ne sera effectué dans l’application. Confirmez les coordonnées {method} avec le commerce avant le transfert.",
  "transferDeliveryInstructions": "Aucun débit ne sera effectué dans l’application. Confirmez les coordonnées {method} avec le commerce ou le livreur avant le transfert.",
  "selectPaymentMethod": "Sélectionnez un mode de paiement", "storeActions": "Actions du commerce", "searchProducts": "Rechercher des produits", "shareStore": "Partager le commerce",
  "storeClosedMenuHelp": "En dehors des horaires d’ouverture. Vous pouvez consulter la carte.", "closeNotice": "Fermer l’avis",
  "searchInStore": "Rechercher dans {store}", "storeCategories": "Catégories du commerce", "customizable": "Personnalisable", "added": "Ajouté",
  "productDetail": "Détail du produit", "customizeAndAdd": "Personnaliser et ajouter", "addToOrder": "Ajouter à la commande", "addedToCart": "Ajouté au panier",
  "storeNotAcceptingOrders": "Ce commerce est fermé et n’accepte pas de commandes actuellement."
};
